import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top for token pages and create token page
    if (location.pathname.startsWith('/coin/') || location.pathname === '/create') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);
};
